export const MAX_SELECTED_VEHICLES = 10;
